import { useContext, useEffect, useMemo } from 'react'

import {
  Box,
  DoughnutChart,
  ThemeColors,
  getThemeColor,
} from '@fairfashion/design-system'
import { useTheme } from 'styled-components'

import { OrderProductionsContext } from '../../order-productions.context'

import * as Styles from './order-productions-statistics.styles'

export const OrderProductionsStatistics = () => {
  const { orderProductionStatistics, actions } = useContext(
    OrderProductionsContext,
  )

  useEffect(() => {
    actions.fetchOrderProductionStatistics()
  }, [])

  const resumeCards = useMemo(() => {
    if (!orderProductionStatistics) return

    const cards = []

    cards.push({
      title: 'Total de processos',
      color: 'lilac',
      value: orderProductionStatistics.total,
    })

    cards.push({
      title: 'Processos concluídos',
      color: 'light_purple',
      value: orderProductionStatistics.completed,
    })

    cards.push({
      title: 'Processos em andamento',
      color: 'purple',
      value: orderProductionStatistics.pending,
    })

    return cards
  }, [orderProductionStatistics])

  const theme = useTheme()

  if (!orderProductionStatistics || !resumeCards) return null

  return (
    <Styles.ResumeCards position="relative" alignItems="center">
      <Styles.ImageBackground src="/assets/card-background.jpeg" />
      <DoughnutChart
        parts={resumeCards.slice(1).map((card) => ({
          value: card.value,
          color: getThemeColor(card.color, theme),
        }))}
        totalValue={orderProductionStatistics.total}
        size={150}
      />
      {resumeCards.map((card) => (
        <Styles.ResumeCard key={card.title}>
          <Box alignItems="center" gap={1}>
            <Styles.ResumeCardBadge color={card.color as ThemeColors} />
            <Styles.ResumeCardTitle>{card.title}</Styles.ResumeCardTitle>
          </Box>
          <Styles.ResumeCardValue>{card.value}</Styles.ResumeCardValue>
        </Styles.ResumeCard>
      ))}
    </Styles.ResumeCards>
  )
}
